import { render, staticRenderFns } from "./message-input-editor-web.vue?vue&type=template&id=0df7c00e&scoped=true"
import script from "./message-input-editor-web.vue?vue&type=script&lang=ts"
export * from "./message-input-editor-web.vue?vue&type=script&lang=ts"
import style0 from "./message-input-editor-web.vue?vue&type=style&index=0&id=0df7c00e&prod&scoped=true&lang=scss"
import style1 from "./message-input-editor-web.vue?vue&type=style&index=1&id=0df7c00e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df7c00e",
  null
  
)

export default component.exports